const FIRM_LOGOS = [
  "/firms/shark-funded.png",
  "/firms/fundingpips.png",
  "/firms/alpha-capital.png",
  "/firms/upcomers.png",
  "/firms/sure-leverage.png",
  "/firms/funderblu.png",
  "/firms/myfundedfutures.png",
  "/firms/funded-futures-family.png",
];

export default function PromoVertical() {
  return (
    <div className="promov-root">
      <style>{`
        .promov-root {
          width: 100vw; height: 100vh; overflow: hidden; position: relative;
          background: radial-gradient(900px 900px at 50% -10%, #1b1140 0%, #0a0a16 55%, #07070f 100%);
          font-family: inherit;
        }
        .promov-grid {
          position: absolute; inset: 0; opacity: .35;
          background-image: linear-gradient(rgba(139,92,246,.07) 1px, transparent 1px),
                            linear-gradient(90deg, rgba(139,92,246,.07) 1px, transparent 1px);
          background-size: 64px 64px;
          mask-image: radial-gradient(ellipse at center, black 30%, transparent 78%);
        }
        .promov-glow { position: absolute; border-radius: 9999px; filter: blur(140px); }
        .vscene { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; opacity: 0; text-align: center; padding: 0 70px; }

        @keyframes vIn { from { opacity: 0; transform: translateY(34px) scale(.985); } to { opacity: 1; transform: translateY(0) scale(1); } }
        @keyframes vOut { to { opacity: 0; transform: translateY(-24px) scale(1.01); } }
        @keyframes vPop { 0% { opacity: 0; transform: scale(.6); } 70% { transform: scale(1.06); } 100% { opacity: 1; transform: scale(1); } }
        @keyframes vRise { from { opacity: 0; transform: translateY(44px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes vLogo { 0% { opacity: 0; transform: scale(.5) rotate(-8deg); filter: drop-shadow(0 0 0 rgba(139,92,246,0)); } 60% { filter: drop-shadow(0 0 60px rgba(139,92,246,.85)); } 100% { opacity: 1; transform: scale(1) rotate(0); filter: drop-shadow(0 0 36px rgba(139,92,246,.55)); } }
        @keyframes vPulse { 0% { box-shadow: 0 0 0 0 rgba(245,197,66,.45); } 100% { box-shadow: 0 0 0 40px rgba(245,197,66,0); } }

        .vs1 { animation: vIn .8s cubic-bezier(.22,1,.36,1) .2s forwards, vOut .6s ease-in 4.6s forwards; }
        .vs2 { animation: vIn .8s cubic-bezier(.22,1,.36,1) 5.2s forwards, vOut .6s ease-in 9.6s forwards; }
        .vs3 { animation: vIn .8s cubic-bezier(.22,1,.36,1) 10.2s forwards, vOut .6s ease-in 14.8s forwards; }
        .vs4 { animation: vIn .8s cubic-bezier(.22,1,.36,1) 15.4s forwards, vOut .6s ease-in 19.8s forwards; }
        .vs5 { animation: vIn .9s cubic-bezier(.22,1,.36,1) 20.4s forwards; }

        .vlogo-anim { animation: vLogo 1.1s cubic-bezier(.22,1,.36,1) .35s both; }
        .vrise { opacity: 0; animation: vRise .7s cubic-bezier(.22,1,.36,1) forwards; }
        .vchip { opacity: 0; animation: vPop .55s cubic-bezier(.22,1,.36,1) forwards; }
        .vgold-rise { opacity: 0; animation: vRise .7s cubic-bezier(.22,1,.36,1) 10.5s forwards, vPulse 1.2s ease-out 11.4s 3; }
      `}</style>

      <div className="promov-grid" />
      <div className="promov-glow" style={{ width: 560, height: 560, left: -180, top: -160, background: "rgba(124,58,237,.28)" }} />
      <div className="promov-glow" style={{ width: 480, height: 480, right: -160, bottom: -160, background: "rgba(59,130,246,.22)" }} />

      {/* Scene 1 — logo reveal */}
      <div className="vscene vs1">
        <img src="/logo-mark.png" alt="" className="vlogo-anim" style={{ width: 260, height: 260, borderRadius: 44 }} />
        <p className="vrise" style={{ animationDelay: "1s", marginTop: 44, fontSize: 20, letterSpacing: 8, color: "#a78bfa", fontWeight: 600 }}>
          FUNDED TRADERS CLUB
        </p>
        <h1 className="vrise" style={{ animationDelay: "1.35s", marginTop: 26, fontSize: 76, fontWeight: 800, color: "#fff", letterSpacing: -2, lineHeight: 1.12 }}>
          Trade funded.<br />
          <span style={{ background: "linear-gradient(90deg,#8b5cf6,#3b82f6)", WebkitBackgroundClip: "text", color: "transparent" }}>Earn cashback.</span>
        </h1>
      </div>

      {/* Scene 2 — firms */}
      <div className="vscene vs2">
        <p className="vrise" style={{ animationDelay: "5.5s", fontSize: 18, letterSpacing: 5, color: "#a78bfa", fontWeight: 600 }}>
          EVERY PROP FIRM.<br />ONE HONEST SCOREBOARD.
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 26, marginTop: 48 }}>
          {FIRM_LOGOS.map((src, i) => (
            <div key={src} className="vchip" style={{ animationDelay: `${5.9 + i * 0.16}s`, width: 168, height: 168, borderRadius: 34, background: src.includes("funderblu") ? "#0d1226" : "#fff", display: "flex", alignItems: "center", justifyContent: "center", padding: 26, boxShadow: "0 16px 50px rgba(0,0,0,.5)" }}>
              <img src={src} alt="" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
            </div>
          ))}
        </div>
        <p className="vrise" style={{ animationDelay: "7.6s", marginTop: 42, fontSize: 24, color: "#9ca3af" }}>
          Real reviews · verified payouts · live prices
        </p>
      </div>

      {/* Scene 3 — code FTC cashback */}
      <div className="vscene vs3">
        <div className="vgold-rise" style={{ border: "2px solid rgba(245,197,66,.55)", background: "rgba(245,197,66,.1)", borderRadius: 40, padding: "56px 80px" }}>
          <p style={{ fontSize: 20, letterSpacing: 6, color: "#f5c542", fontWeight: 600 }}>USE CODE</p>
          <p style={{ fontSize: 170, fontWeight: 900, color: "#f5c542", letterSpacing: 10, lineHeight: 1.05, marginTop: 8 }}>FTC</p>
        </div>
        <p className="vrise" style={{ animationDelay: "11.3s", marginTop: 52, fontSize: 36, fontWeight: 700, color: "#fff", lineHeight: 1.35 }}>
          Our commission becomes<br /><span style={{ color: "#f5c542" }}>your cashback</span> — up to 15%
        </p>
        <p className="vrise" style={{ animationDelay: "11.9s", marginTop: 18, fontSize: 24, color: "#9ca3af" }}>
          on every account, at every listed firm
        </p>
      </div>

      {/* Scene 4 — features */}
      <div className="vscene vs4">
        <p className="vrise" style={{ animationDelay: "15.7s", fontSize: 18, letterSpacing: 5, color: "#a78bfa", fontWeight: 600 }}>BUILT FOR FUNDED TRADERS</p>
        <div style={{ display: "flex", flexDirection: "column", gap: 22, marginTop: 44, width: "100%", maxWidth: 820 }}>
          {[
            ["Honest Reviews", "Member-rated firms with verified badges"],
            ["Payout Proof Feed", "Real payouts, desk-verified certificates"],
            ["FTC Coin Wallet", "Cashback coins, UPI & crypto cashout"],
            ["Refer & Earn", "0.15 coin for you and every friend"],
          ].map(([t, d], i) => (
            <div key={t} className="vchip" style={{ animationDelay: `${16.1 + i * 0.2}s`, borderRadius: 26, background: "rgba(18,18,31,.9)", border: "1px solid rgba(139,92,246,.3)", padding: "30px 38px", textAlign: "left" }}>
              <p style={{ fontSize: 28, fontWeight: 800, color: "#fff" }}>{t}</p>
              <p style={{ marginTop: 8, fontSize: 21, lineHeight: 1.5, color: "#9ca3af" }}>{d}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scene 5 — CTA */}
      <div className="vscene vs5">
        <p className="vrise" style={{ animationDelay: "20.8s", fontSize: 20, letterSpacing: 8, color: "#a78bfa", fontWeight: 600 }}>JOIN THE CLUB</p>
        <h1 className="vrise" style={{ animationDelay: "21.2s", marginTop: 26, fontSize: 64, fontWeight: 900, color: "#fff", letterSpacing: -1, lineHeight: 1.15 }}>
          fundedtradersclub<span style={{ color: "#8b5cf6" }}>.in</span>
        </h1>
        <div className="vrise" style={{ animationDelay: "21.8s", marginTop: 52, background: "linear-gradient(90deg,#3b82f6,#8b5cf6)", borderRadius: 999, padding: "26px 64px", fontSize: 28, fontWeight: 800, color: "#fff", boxShadow: "0 18px 60px rgba(124,58,237,.5)" }}>
          Sign up free — start earning cashback
        </div>
        <p className="vrise" style={{ animationDelay: "22.4s", marginTop: 34, fontSize: 18, letterSpacing: 4, color: "#6b7280" }}>
          REVIEWS · PAYOUTS · COINS · REFERRALS
        </p>
      </div>
    </div>
  );
}
